<template>
  <main
    class="ten-main"
    v-bind="$attrs"
  >
    <!-- @slot Main 内容 -->
    <slot />
  </main>
</template>

<script>
const name = 'ten-main';
export default {
  name,
};
</script>
